import { defineMessages } from 'react-intl';

// Validation messages
export const validationMessages = defineMessages({
  'feedbackmodal.error.body': {
    id: 'feedbackmodal.error.body',
    defaultMessage: 'This field is required',
  },
});

// Feedback type options
export const typeOfFeedbacks = defineMessages({
  technicalIssue: {
    id: 'feedback.modal.typeoffeedbacks.technical.issue',
    defaultMessage: 'There is an (technical) issue with the website',
  },
  missingSomething: {
    id: 'feedback.modal.typeoffeedbacks.missing.something',
    defaultMessage: 'I am missing something',
  },
  pricingIssue: {
    id: 'feedback.modal.typeoffeedbacks.pricing.issue',
    defaultMessage: 'I want to comment on pricing',
  },
  complaint: {
    id: 'feedback.modal.typeoffeedbacks.compliment',
    defaultMessage: 'I want to give a Compliment',
  },
  others: {
    id: 'feedback.modal.typeoffeedbacks.others',
    defaultMessage: 'Something else..',
  },
});

export const generalMessages = defineMessages({
  feedbackmodalIntro: {
    id: 'feedbackmodal.intro',
    defaultMessage: 'We value your feedback! Use this form to help us improve our services and website.',
  },
});
